<template>

  <div
    class="reports"
    v-sortable="{ handle: '.sortable-move', items: components, axis: false, onUpdate: reorder }">
    <div
      v-for="(dashcomponent, i) in components"
      :key="dashcomponent._id"
      :class="'report-' + dashcomponent.width_num">
      <DashcomponentMosaicItem
        :dashcomponent="dashcomponent"
        :dashboardId="dashcomponent._id" />
      </div>
  </div>

</template>

<script>
// import _ from 'lodash'
import DashcomponentMosaicItem from './DashcomponentMosaicItem'

export default {
  name: 'DashcomponentMosaic',
  components: {
    DashcomponentMosaicItem
  },
  props: {
    dashboardId: {
      type: String
    },
    dashcomponents: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    components: {
      get () {
        return this.dashcomponents
      },
      set () {}
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    reorder (items) {
      this.$store.dispatch('sortDashcomponent', items.map((item, index) => {
        return {
          _id: item._id,
          dashboard_id: this.dashboardId,
          position: index
        }
      }))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.reports {
  background: rgba(0,0,0,0.05);
  padding: 6px;
  display: flex;
  flex-wrap: wrap;
}
  .reports > * {
    padding: 6px;
  }
  .reports > .report-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .reports > .report-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .reports > .report-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .reports > .report-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  @media only screen and (max-width: 900px) {
    .reports > .report-3 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .reports > .report-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .reports > .report-9 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .reports > .report-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashcomponentMosaic.vue